/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./external-cost-update-action-body').ExternalCostUpdateActionBody} ExternalCostUpdateActionBody
 */

/**
 * @typedef {import('./external-cost-update-action-response').ExternalCostUpdateActionResponse} ExternalCostUpdateActionResponse
 */

/**
 * The path of the ExternalCostUpdateAction action.
 */
export const externalCostUpdateActionPath = new SweetPath('/api/finance/external_cost/{external_cost_id}', {
  path: '{param}',
});

/**
 * Creates a contextualized ExternalCostUpdateAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createExternalCostUpdateAction(axios) {
  /**
   * The externalCostUpdateAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: ExternalCostUpdateActionBody } }
   *
   * @returns {Promise<ExternalCostUpdateActionResponse>}
   */
  function externalCostUpdateAction({ headers = {}, parameters = {}, body } = {}) {
    const path = externalCostUpdateActionPath.insert(parameters);

    return axios.put(path, body, { headers });
  }

  return externalCostUpdateAction;
}
